// import React, { Fragment } from 'react';
// import { useAuth0 } from "@auth0/auth0-react";
// // import Button from '@mui/material/Button';

// export default function TestPage() {
//   //var displayName = Home.name;

//   const { isAuthenticated } = useAuth0();

//   return (
//     <Fragment>



//       <div>
//         <p>Welcome to your new single-page application, built with:</p>
//         <ul>
//           <li><a href='https://get.asp.net/'>ASP.NET Core</a> and <a href='https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx'>C#</a> for cross-platform server-side code</li>
//           <li><a href='https://facebook.github.io/react/'>React</a> for client-side code</li>
//           <li><a href='http://getbootstrap.com/'>Bootstrap</a> for layout and styling</li>
//         </ul>
//         <p>To help you get started, we have also set up:</p>
//         <ul>
//           <li><strong>Client-side navigation</strong>. For example, click <em>Counter</em> then <em>Back</em> to return here.</li>
//           <li><strong>Development server integration</strong>. In development mode, the development server from <code>create-react-app</code> runs in the background automatically, so your client-side resources are dynamically built on demand and the page refreshes when you modify any file.</li>
//           <li><strong>Efficient production builds</strong>. In production mode, development-time features are disabled, and your <code>dotnet publish</code> configuration produces minified, efficiently bundled JavaScript files.</li>
//         </ul>
//         <p>The <code>ClientApp</code> subdirectory is a standard React application based on the <code>create-react-app</code> template. If you open a command prompt in that directory, you can run <code>npm</code> commands such as <code>npm test</code> or <code>npm install</code>.</p>
//       </div>

//     </Fragment>
//   );

// }

import React, { useState, useEffect, Fragment } from "react";
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack, Alert, Collapse } from '@mui/material';
//import Profile from "./Profile";
import { useAuth0 } from "@auth0/auth0-react";
import CustomToolbar from "./Widgets/CustomToolbar";
import VendorRequestDialog from "./VendorRequest";
import SuccessError from "./Widgets/SuccessError";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import VendorRequestHistoryCard from "./Widgets/VendorRequestHistoryCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Calculate, Dataset, Mail } from "@mui/icons-material";
import { FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import { Controller } from "react-hook-form";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import { set } from "date-fns";
import { da, de } from "date-fns/locale";
import _without from "lodash/without";
import { useSearchParams } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { differenceBy, get } from "lodash";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import dayjs from 'dayjs';
import RadioGroup from '@mui/material/RadioGroup';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import { data } from "jquery";
import { sys } from "typescript";




var refreshData = 1;
export default function DataUsers() {


  var reRender = 1;

  const useAsyncLoad = (url, anonymous) => {

    const [errorA, setErrorA] = useState(null);
    const [loading, setLoading] = useState(true);
    const [vendors, setVendors] = useState(null);

    const x = reRender;

    async function GetDataUserData(url) {

      if (!anonymous) {
        //const audience = 'https://piaapplication.azurewebsites.net/';

        // const accessToken = await getAccessTokenSilently({
        //   audience: audience,
        //   //scope: "read:messages",
        // });

        // var bearer = 'Bearer ' + accessToken;

        const accessToken = localStorage.getItem("userToken");

        var userData = await fetch(url, {
          method: 'GET',
          withCredentials: !anonymous,
          credentials: 'include',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          }
        });

        var data = await userData.json();

        data.accessToken = accessToken;
        //console.log(data);
        return data;
      }
      else {
        var userData = await fetch(url, {
        });

        var data = await userData.json();
        // console.log(data);
        return data;
      }
      //return data;
    };


    async function loadData(url) {

      try {

        setErrorA(null);
        // if (x < 2) {
        //   setLoading(true);
        // }

        var data = await GetDataUserData(url);

        setVendors(data);
        //console.log(data);

      } catch (e) {
        setLoading(false);
        setErrorA(e);
      } finally {
        setLoading(false);
      }
    }

    useEffect(() => {
      loadData(url);
      // eslint-disable-next-line
    }, [refreshData]);

    return [vendors, errorA, loading];
  }


  const FetchRecords = () => {
    const [value, error, loading] = useAsyncLoad("datausers/getdatausers", false);
    return [value, error, loading];
  }
  const FetchRecord = (id) => {

    const [searchParams, setSearchParams] = useSearchParams();
    var tenant = searchParams.get('tenantId');

    const [value, error, loading] = useAsyncLoad("public/getdatauseranonymous?id=" + id + "&tenantId=" + tenant, true);

    return [value, error, loading];
  }



  const [open, setOpen] = React.useState(false);
  const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [systemAccessDeleteOpen, setSystemAccessDeleteOpen] = React.useState(false);
  const [deleteName, setDeleteName] = React.useState('');
  const [deleteId, setDeleteId] = React.useState('');
  const [dataUserIdForSystemAccessDelete, setDataUserIdForSystemAccessDelete] = React.useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
  const [accessToken, setAccessToken] = useState();
  const [departments, setDepartments] = useState([]);
  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [employmentTypeOtherShow, setEmploymentTypeOtherShow] = useState(false);
  const [dataSystems, setDataSystems] = useState([]);
  const [generalOpen, setGeneralOpen] = useState(true);
  const [systemAccessOpen, setSystemAccessOpen] = useState(true);
  const [dataAccessOpen, setDataAccessOpen] = useState(false);
  const [dataTypesSelected, setDataTypesSelected] = useState([]);
  const [dataTypesItems, setDataTypesItems] = useState([]);
  const [dataSignoff, setDataSignOff] = React.useState(false);
  const [newAccessRecords, setNewAccessRecords] = React.useState([]);
  const [filt, setFilt] = useState([])
  const [searchParams] = useSearchParams();
  const [declarationOpen, setDeclarationOpen] = React.useState(false);
  const [accessLevels, setAccessLevels] = useState([]);
  const [accessPurposes, setAccessPurposes] = useState([]);
  const [accessPurposeSelected, setAccessPurposeSelected] = useState([]);
  const [dataUses, setDataUses] = useState([]);
  const [dataUsesSelected, setDataUsesSelected] = useState([]);
  const [dataStorageItems, setDataStorageItems] = useState([]);
  const [dataStorageSelected, setDataStorageSelected] = useState([]);
  const [accessMethodItems, setAccessMethodItems] = useState([]);
  const [accessMethodSelected, setAccessMethodSelected] = useState([]);
  const [riskLevel, setRiskLevel] = useState(0);
  const [riskLevelButton, setRiskLevelButton] = useState(0);
  const [riskText, setRiskText] = useState('');
  const [dataSystemId, setDataSystemId] = useState(null);
  const [accessLevelId, setAccessLevelId] = useState(null);
  const [dataSystemUserId, setDataSystemUserId] = useState(null);
  const [dataUserRowData, setDataUserRowData] = useState(null);


  // setRiskLevel(0);

  const requestCode = searchParams.get("id"); //this is the id of the data user declaration/request

  const UrlRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');

  const validationSchema = Yup.object().shape({
    id: Yup.number(),
    firstName: Yup.string()
      .required('First Name is required')
      .max(150, 'First Name must not exceed 150 characters'),
    lastName: Yup.string()
      .required('Last Name is required')
      .max(150, 'Last Name must not exceed 150 characters'),
    email: Yup.string()
      .required('Email is required')
      .email('Email is invalid')
      .max(250, 'Email must not exceed 250 characters'),
    departmentId: Yup.number()
      .required('Department is required'),
    employmentTypeId: Yup.number(),
    employmentTypeOther: Yup.string().when('employmentTypeId', {
      is: (val) => employmentTypes.find(x => x.id === val)?.name === 'Other',
      then: Yup.string().required('Please specify other employment type').max(150, 'Other Employment Type must not exceed 150 characters'),
      otherwise: Yup.string().nullable(true)
    }),

    // dataSystemId: Yup.number()
    //   .required('System and Module is required'),
    dataUse: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Use must not exceed 500 characters'),
    dataRetention: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Retention must not exceed 500 characters'),

    dataSignoff: Yup.boolean()


  });
  const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
    '&.Mui-selected, &.Mui-selected:hover': {
      color: 'white',
      backgroundColor: selectedColor,
    },
  }));
  const handleRiskLevelChange = (event, newValue) => {
    //don't allow manual change, risk level is calculated based on data types selected
    //setRiskLevel(newValue);
  };
  const handleRiskText = function (newValue) {

    setRiskText(newValue);
  };
  const validationSchemaSystemAccess = Yup.object().shape({
    id: Yup.number(),
    dataSystemId: Yup.number()
      .required('System and Module is required'),
    // dataUse: Yup.string()
    //   //.required('Last Name is required')
    //   .max(500, 'Data Use must not exceed 500 characters'),
    // dataRetention: Yup.string()
    //   //.required('Last Name is required')
    //   .max(500, 'Data Retention must not exceed 500 characters'),
    accessLevelId: Yup.number(),

    dataSignoff: Yup.boolean()
  });


  const handleDataTypesChange = (event) => {
    const {
      target: { value },
    } = event;
    setDataTypesSelected(typeof value === 'string' ? value.split(',') : value,);
  };

  const handleAccessPurposeChange = (event) => {
    const {
      target: { value },
    } = event;
    setAccessPurposeSelected(typeof value === 'string' ? value.split(',') : value,);
    calculateRiskLevel();
  };


  const handleDataStorageChange = (event) => {
    const {
      target: { value },
    } = event;
    setDataStorageSelected(typeof value === 'string' ? value.split(',') : value,);
    calculateRiskLevel();
  };

  const handleAccessMethodChange = (event) => {
    const {
      target: { value },
    } = event;
    setAccessMethodSelected(typeof value === 'string' ? value.split(',') : value,);
    calculateRiskLevel();
  };



  const handleDataUsesChange = (event) => {
    const {
      target: { value },
    } = event;
    setDataUsesSelected(typeof value === 'string' ? value.split(',') : value,);
    calculateRiskLevel();
  };
  const handleChipDeleteForDataUses = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));

    calculateRiskLevel();
  };

  const calculateRiskLevel = () => {

    //calculate risk level based on data types selected using the maximum risk level of any data type selected
    var riskLevelPoints = 0;
    //find the selected risk level item

    if (getValues("accessLevelId") > 0) {
      var accessLevel = accessLevels.find(x => x.lookupItemId === getValues("accessLevelId"));
      if (accessLevel) {
        if (accessLevel.name === 'Administrator') {
          riskLevelPoints += 5;
        }
        if (accessLevel.name === 'Viewer') {
          riskLevelPoints += 2;
        }
      }
    }
    //date uses selected points
    if (dataUsesSelected) {
      dataUsesSelected.find(x => x === 'Download/export data') && (riskLevelPoints += 4);
      dataUsesSelected.find(x => x === 'Share information externally') && (riskLevelPoints += 4);
      dataUsesSelected.find(x => x === 'Download/export data') && (riskLevelPoints += 4);
      dataUsesSelected.find(x => x === 'Print Records') && (riskLevelPoints += 2);
      dataUsesSelected.find(x => x === 'Generate reports or analytics') && (riskLevelPoints += 2);
      dataUsesSelected.find(x => x === 'Manage system settings or permissions') && (riskLevelPoints += 5);

    }
    if (dataStorageSelected) {
      dataStorageSelected.find(x => x === 'Store files locally on my device') && (riskLevelPoints += 4);
    }
    if (accessMethodSelected) {
      accessMethodSelected.find(x => x === 'Personal devices') && (riskLevelPoints += 3);
      accessMethodSelected.find(x => x === 'Remote/home access') && (riskLevelPoints += 2);
      accessMethodSelected.find(x => x === 'Access while travelling internationally') && (riskLevelPoints += 2);
    }
    //type of parent data system 

    var parentDataSystem = dataSystems.find(x => x.id === getValues("dataSystemId"));
    if (parentDataSystem) {
      var dataSystemType = parentDataSystem.dataSystemType;
      if (dataSystemType === 0) {
      } else if (dataSystemType === 1) {
        riskLevelPoints += 2;
      } else if (dataSystemType === 2) {
        riskLevelPoints += 3;
      } else if (dataSystemType === 3) {
        riskLevelPoints += 5;
      }

    }
    if (accessPurposeSelected) {
      accessPurposeSelected.find(x => x === 'Safeguarding / Child Protection') && (riskLevelPoints += 5);
      accessPurposeSelected.find(x => x === 'Student Wellbeing and Support') && (riskLevelPoints += 4);
      accessPurposeSelected.find(x => x === 'Learning Support/Inclusion') && (riskLevelPoints += 4);
      accessPurposeSelected.find(x => x === 'Human Resources Administration') && (riskLevelPoints += 4);
    }

    if (employmentTypes.find(x => x.id === getValues("employmentTypeId"))?.name === 'Contractor') {
      riskLevelPoints += 3;
    }
    if (employmentTypes.find(x => x.id === getValues("employmentTypeId"))?.name === 'Volunteer') {
      riskLevelPoints += 3;
    }
    if (employmentTypes.find(x => x.id === getValues("employmentTypeId"))?.name === 'Temporary Staff') {
      riskLevelPoints += 3;
    }
    // debugger;
    setRiskLevel(riskLevelPoints);

    if (riskLevelPoints <= 4) {
      setRiskLevelButton(0);
    }
    else if (riskLevelPoints > 4 && riskLevelPoints <= 9) {
      setRiskLevelButton(1);
    }
    else if (riskLevelPoints > 9 && riskLevelPoints <= 16) {
      setRiskLevelButton(2);
    }
    else if (riskLevelPoints > 16) {
      setRiskLevelButton(3);
    }

  }
  const handleChipDeleteForDataTypes = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    // if (value === 'Other') {
    //   setotherDepartmentsShow(false);
    // }
  };

  const handleChipDeleteForAccessPurposes = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    calculateRiskLevel();
  };

  const handleChipDeleteForDataStorage = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    calculateRiskLevel();
  };

  const handleChipDeleteForAccessMethods = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    calculateRiskLevel();
  };

  const handleDataSignOffChange = (event) => {
    setDataSignOff(event.target.checked);
  };
  const onSubmit = data => {
    debugger;
    if (data.id === -1) {
      saveDataUser(data, 'Add', accessToken);
    } else {
      saveDataUser(data, 'Save', accessToken);
    }
    setEditOpen(false);

  };

  const onSubmitComplete = data => {

    data.completionStatus = 2; //complete
    data.dataSignoff = dataSignoff;
    if (dataSignoff === false) {
      showErrorDialog("You must agree to the data privacy policy sign off to complete the declaration");
      return;
    }
    saveDataUser(data, 'Save', accessToken);

    setEditOpen(false);

  };

  const onSubmitInProgress = data => {
    if (dataSignoff === false) {
      showErrorDialog("You must agree to the data privacy policy sign off to complete the declaration");
      return;
    }
    data.completionStatus = 1; //in progress
    data.dataSignoff = dataSignoff;
    saveDataUser(data, 'Save', accessToken);

    setEditOpen(false);
  };


  const onSubmitSystemAccess = data => {
    //has to be saved in memory at this point
    var dataSystemDisplay = recordData.dataSystems.find(x => x.id === data.dataSystemId).system;
    var moduleDisplay = recordData.dataSystems.find(x => x.id === data.dataSystemId).module;
    dataSystemDisplay = dataSystemDisplay + ' - ' + moduleDisplay;
    debugger;
    if (data.systemAccessId === -1) { //add
      //save to temp array
      //find the smallest id in dataSystemUsers array and subtract 1
      var newId = -1;
      if (recordData.dataSystemUsers.length > 0) {
        var minId = Math.min.apply(Math, recordData.dataSystemUsers.map(function (o) { return o.id; }));
        if (minId < 0) {
          newId = minId - 1;
        }
      }

      var itemToAdd = {
        id: newId,
        dataUserId: data.id,
        dataSystemId: data.dataSystemId,
        dataUse: data.dataUse,
        dataRetention: data.dataRetention,
        selectedDataTypes: dataTypesSelected,
        dataSignoff: dataSignoff,
        dataSystemName: dataSystemDisplay,
        accessLevelId: data.accessLevelId,
        accessPurposeSelected: accessPurposeSelected,
        dataUsesSelected: dataUsesSelected,
        dataStorageSelected: dataStorageSelected,
        accessMethodSelected: accessMethodSelected
      }
      setNewAccessRecords([...newAccessRecords, itemToAdd]);
      //add to the grid
      recordData.dataSystemUsers = [...recordData.dataSystemUsers, itemToAdd];
    } else { //updating
      //find the item in the array and update it

      var itemToUpdate = recordData.dataSystemUsers.find(x => x.dataUserId === data.id);
      if (itemToUpdate) {
        itemToUpdate.dataSystemId = data.dataSystemId;
        itemToUpdate.dataUse = data.dataUse;
        itemToUpdate.dataRetention = data.dataRetention;
        itemToUpdate.selectedDataTypes = dataTypesSelected;
        itemToUpdate.dataSignoff = dataSignoff;
        itemToUpdate.dataSystemName = dataSystemDisplay;
        itemToUpdate.accessLevelId = data.accessLevelId;
        itemToUpdate.accessPurposeSelected = accessPurposeSelected;
        itemToUpdate.dataUsesSelected = dataUsesSelected;
        itemToUpdate.dataStorageSelected = dataStorageSelected;
        itemToUpdate.accessMethodSelected = accessMethodSelected;
      }


    }
    setDataAccessOpen(false);
  };


  const handleDataSignoffChange = () => {
    systemAccessForm.setValue('dataSignoff', !dataSignoff);
    setValue('dataSignoff', !dataSignoff);
    setDataSignOff(!dataSignoff);
  };

  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setTimeout(() => setSuccessOpen(false), 3000);
  };

  const showError = message => {
    setErrorOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  const showErrorDialog = message => {
    setErrorDialogOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorDialogOpen(false), 3000);
  };

  const setUserValues = (dataRow) => {

    setValue("id", dataRow.id);
    setValue("firstName", dataRow.firstName);
    setValue("lastName", dataRow.lastName);
    setValue("email", dataRow.email);
    setValue("departmentId", dataRow.departmentId);
    setValue("employmentTypeId", dataRow.employmentTypeId);
    setValue("employmentTypeOther", dataRow.employmentTypeOther);
    if (dataRow.employmentTypeId == -1) {
      setEmploymentTypeOtherShow(true);
    }
    setEditOrAddTitle('Edit Declaration For ');
  };

  async function saveDataUser(dataUser, saveOrAddOrDelete, accessToken) {

    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
      method = 'POST';
      url = 'datausers/';
    } else if (saveOrAddOrDelete === 'Save') {
      method = 'PUT';
      if (requestCode === null) {
        url = 'datausers/' + dataUser.id;
      } else {

        url = 'datausers/saveanon';
      }
    }
    else if (saveOrAddOrDelete === 'Delete') {
      method = 'DELETE';
      url = 'datausers/' + dataUser.id;
    }
    else if (saveOrAddOrDelete === 'Send') {
      method = 'POST';
      url = 'datausers/senddeclaration';
    }
    else if (saveOrAddOrDelete === 'SendAll') {
      method = 'GET';
      url = 'datausers/sendalldeclarations';
    }

    var bearer = localStorage.getItem("userToken");


    if (dataUser) {
      dataUser.dataSystemUsers = recordData.dataSystemUsers; //all of these will need to be saved
    }


    try {
      var requestOptions = {};
      if (method === 'GET') {
        requestOptions = {
          method: method,
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'
          }
        };
      }
      else {
        // debugger;
        requestOptions = {
          method: method,
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataUser)
        };
      }

      var result = await fetch(url, requestOptions);


      if (result.status === 500) {
        showError("Error sending declarations");
      } else if (result.status === 404) {
        showError("Error sending declarations");
      }

      else {
        switch (saveOrAddOrDelete) {
          case 'Save':
            showSuccess("Update Successful");
            break;
          case 'Add':
            showSuccess("New record added successfully");
            break;
          case 'Delete':
            showSuccess("Record Deleted");
            break;
          case 'Send':
            showSuccess("Declaration successfully sent to user");
          default:
            showSuccess("Update Successful");
        }
      }
    } catch (e) {

      showError();
    } finally {

      refreshData = refreshData + 1;

      //console.log(reRender);
    }
  }

  const {
    register,
    control,
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const systemAccessForm = useForm({
    resolver: yupResolver(validationSchemaSystemAccess)
  });

  // const {
  //   register: registerSystemAccess,
  //   control: controlSystemAccess,
  //   setValue: setValueSystemAccess,
  //   getValues: getValuesSystemAccess,
  //   handleSubmit: handleSubmitSystemAccess,
  //   clearErrors: clearErrorsSystemAccess,
  //   formState: { errors: errorsSystemAccess }
  // } = useForm({
  //   resolver: yupResolver(validationSchemaSystemAccess)
  // });

  const runValidations = () => {
    debugger;
    validationSchemaSystemAccess
      .validate(returnData[0].dataSystemUsers[0], { abortEarly: false })
      .then((responseData) => {
        console.log("no validation errors");
        console.log(responseData);
        console.log(errors);
        //setCurrentErrors([]);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.name); // ValidationError
        console.log(err.errors);
        //setCurrentErrors(err.errors);
      });
  };


  const columns = [
    {
      field: "Actions", width: 210, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleClickOpen(event, cellValues, recordData.accessToken);
              }}
            >
              <EditIcon />
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleDeleteOpen(event, cellValues);
              }}
            >
              <DeleteIcon />
            </Button>
            <Tooltip title="Send Declaration to user" arrow>
              <Button
                variant="outlined"
                color="primary"
                onClick={(event) => {
                  sendDeclaration(event, cellValues, recordData.accessToken);
                }}
              >
                <Mail />
              </Button>
            </Tooltip>

          </div>
        );
      }
    },
    { field: 'name', headerName: 'Last Name, First Name', minWidth: 130, flex: 1 },
    { field: 'email', headerName: 'Email', minWidth: 130, flex: 1 },
    { field: 'departmentName', headerName: 'Department', minWidth: 130, flex: 1 },
    {
      field: 'completionStatus', headerName: 'Completion Status', minWidth: 190, flex: 1,
      renderCell: (cellValues) => {
        if (cellValues.row.completionStatus == 0) {
          return (<Typography color={'white'} bgcolor={'red'}  >Incomplete</Typography>)
        }
        else if (cellValues.row.completionStatus == 1) {
          return (<Typography color={'black'} bgcolor={'yellow'}  >In Progress</Typography>)
        }
        else if (cellValues.row.completionStatus == 2) {
          return (<Typography color={'white'} bgcolor={'green'}  >Complete</Typography>)
        }

        else return (<Typography>not specified</Typography>)
      }
    },
    {
      field: 'completionDate', headerName: 'Completion Date', minWidth: 130, flex: 1,

      renderCell: (cellValues) => {
        if (cellValues.row.completionStatus == 2) {
          var compDate = new Date(cellValues.row.completionDate);
          var day = compDate.getDate();
          var month = compDate.getMonth();
          var year = compDate.getFullYear();
          return (<Typography>{day}/{month + 1}/{year}</Typography>)
        }

      }
    },
    { field: 'employmentTypeId', headerName: 'Employment Type', minWidth: 130, flex: 1, hide: true },
    { field: 'employmentTypeOther', headerName: 'Employment Type Other', minWidth: 130, flex: 1, hide: true },


  ];
  const columnsUserAccess = [
    {
      field: "Actions", width: 150, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleUserAccessClickOpen(event, cellValues, recordData.accessToken);
              }}
            >
              <EditIcon />
            </Button>
            {/* } */}

            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleSystemAccessDeleteOpen(event, cellValues);
              }}
            >
              <DeleteIcon />
            </Button>

          </div>
        );
      }
    },
    { field: 'dataSystemName', headerName: 'System', minWidth: 130, flex: 1 },
    { field: 'id', headerName: '', minWidth: 130, flex: 1, hide: true },
    { field: 'dataUserId', headerName: 'id', minWidth: 130, flex: 1, hide: true },
    { field: 'completionDate', headerName: 'Completion Date', minWidth: 130, flex: 1, hide: true },
    { field: 'dataSystemId', headerName: 'Data System ID', minWidth: 130, flex: 1, hide: true },
    { field: 'accessLevelId', headerName: 'Access Level ID', minWidth: 130, flex: 1, hide: true },
    // { field: 'departmentName', headerName: 'Department', minWidth: 130, flex: 1 },


  ];


  if (requestCode === null) { //all data users
    var returnData = FetchRecords();
    var recordData = returnData[0];
  }
  else { //only the data user with the id
    var returnData = FetchRecord(requestCode);
    var recordData = returnData[0];

  }
  // console.log(returnData);

  if (requestCode === null) {

    if (recordData && !accessToken) {

      setAccessToken(recordData.accessToken);
      setDepartments(recordData.departments);
      setDataSystems(recordData.dataSystems);
      setAccessLevels(recordData.accessLevels);
      setDataTypesItems(recordData.dataTypes);
      setEmploymentTypes(recordData.employmentTypes);
      setAccessPurposes(recordData.accessPurposes);
      setDataUses(recordData.dataUses);
      setAccessMethodItems(recordData.accessMethods);
      setDataStorageItems(recordData.dataStorage);

      console.log(recordData);

    }
  }
  else {

    if (recordData && dataTypesItems.length === 0) {

      setDepartments(recordData.departments);
      setDataSystems(recordData.dataSystems);
      setAccessLevels(recordData.accessLevels);
      setDataTypesItems(recordData.dataTypes);
      setEmploymentTypes(recordData.employmentTypes);
      setAccessPurposes(recordData.accessPurposes);
      setDataUses(recordData.dataUses);
      setDataStorageItems(recordData.dataStorage);
      setAccessMethodItems(recordData.accessMethods);
      setEditOrAddTitle('Edit Declaration For ');

      setDataSignOff(recordData.dataUsers[0].dataSignOff);
      //open the dialog
      if (recordData.dataUsers.length > 0) {
        setUserValues(recordData.dataUsers[0]);
      }

      setEditOpen(true);

    }

  }
  // systemAccessForm.setValue("dataSystemId", recordData.dataSystemUsers && recordData.dataSystemUsers.length > 0 ? recordData.dataSystemUsers[0].dataSystemId : null);
  // systemAccessForm.setValue("dataUse", recordData.dataSystemUsers && recordData.dataSystemUsers.length > 0 ? recordData.dataSystemUsers[0].dataUse : '');
  systemAccessForm.setValue('dataSystemId', null);
  systemAccessForm.setValue('accessLevelId', null);
  var loading = returnData[2];
  var error = returnData[1];
  const handleClipboardCopy = () => {
    var currentUrl = window.location.href;

    var url = currentUrl.split('?')[0] + '?id=new&tenantId=' + recordData.userAndTenant.tenantId;

    navigator.clipboard.writeText(url);

    var spanItem = document.getElementById('copiedMsg');
    //console.log(tooltip);
    spanItem.innerHTML = '&nbsp;&nbsp;&nbsp; Copied!';

    setTimeout(function () {
      spanItem.innerHTML = '';
    }, 1000);

  };

  const handleClickOpen = (event, cellValues, accessToken) => {

    var dataRow = cellValues.row;
    setFilt([
      {
        columnField: "dataUserId",
        operatorValue: "equals",
        value: dataRow.id.toString()
      }
    ])

    debugger;
    setUserValues(dataRow)
    //need to make a copy of the data in case of cancellation;
    setDataUserRowData(recordData.dataSystemUsers);

    setEditOpen(true);
    
  };

  const sendDeclaration = (event, cellValues, accessToken) => {
    var dataRow = cellValues.row;
    //need to show confirmation dialog before sending
    if(!window.confirm("Are you sure you want to send the declaration to " + dataRow.name + "?")){
      return;
    }

    saveDataUser(dataRow, 'Send', accessToken);  //send declaration
  }
  const sendAllDeclarations = () => {
    //saveDataUser(null, 'SendAll', recordData.accessToken);  //send declaration
    setDeclarationOpen(true);
  }

  const handleUserAccessClickOpen = (event, cellValues, accessToken) => {

    var dataRow = cellValues.row;
    setDataSystemUserId(dataRow.id);
    //setValue("id", dataRow.id);

    // setValue("dataSystemId", dataRow.dataSystemId.toString());

    if (dataRow.dataSystemId) {
      setDataSystemId(dataRow.dataSystemId);
    }
    if (dataRow.accessLevelId) {
      setAccessLevelId(dataRow.accessLevelId);
    }
    //systemAccessForm.setValue("dataSystemId", dataRow.dataSystemId.toString());
    // setValue("dataUse", dataRow.dataUse);
    // setValue("dataRetention", dataRow.dataRetention);
    // setD ataTypesSelected(dataRow.selectedDataTypes);
    //setValue("dataTypesSelected", dataRow.dataTypesSelected);
    // setValue("dataSignoff", dataRow.dataSignOff);
    // setValue("completionDate", dayjs(dataRow.completionDate).format('YYYY-MM-DD'));
    // setDataSignOff(dataRow.dataSignOff);
    // setValue("id", dataRow.id);
    //systemAccessForm.setValue("accessLevelId", dataRow.accessLevelId.toString());
    setAccessPurposeSelected(dataRow.accessPurposeSelected);
    setDataUsesSelected(dataRow.dataUsesSelected);
    setDataStorageSelected(dataRow.dataStorageSelected);
    setAccessMethodSelected(dataRow.accessMethodSelected);
    //console.log(recordData.departments);
    setEditOrAddTitle('Edit');
    setDataAccessOpen(true);

    calculateRiskLevel();
  };

  const addDataUser = (event, cellValues) => {

    setValue("id", -1);
    setValue("firstName", '');
    setValue("lastName", '');
    setValue("email", '');
    setValue("departmentId", '');
    setEditOpen(true);
    setEditOrAddTitle('Add');
    setFilt([
      {
        columnField: "dataUserId",
        operatorValue: "equals",
        value: "-1"
      }
    ])
    clearErrors();
    setOpen(true);

  };

  const addSystemAccess = (data) => {
    setDataSystemId(null);
    setAccessLevelId(null); 
    //setValue("systemAccessId", -1);
    //systemAccessForm.setValue("dataSystemId", null);
    //setValue("dataSystemId", null);
    systemAccessForm.setValue("dataUse", '');
    setValue("dataUse", '');
    systemAccessForm.setValue("dataRetention", '');
    setValue("dataRetention", '');
    setDataTypesSelected([]);
    setDataSignOff(false);
    setEditOrAddTitle('Add');
    setAccessPurposeSelected([]);
    setDataUsesSelected([]);
    setDataStorageSelected([]);
    setAccessMethodSelected([]);

    clearErrors();
    setDataAccessOpen(true);
  }


  const handleDeleteOpen = (event, cellValues) => {

    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);
    setDeleteId(dataRow.id)
    setDeleteOpen(true);
  };

  const handleSystemAccessDeleteOpen = (event, cellValues) => {
    // debugger;
    var dataRow = cellValues.row;
    setDeleteName(dataRow.dataSystemName);
    setDeleteId(dataRow.dataSystemId);
    setDataUserIdForSystemAccessDelete(dataRow.dataUserId);
    setSystemAccessDeleteOpen(true);
  };

  const handleCancel = (event, reason) => {
    debugger;
    if (reason && reason === "backdropClick")
      return;
    //revert to original data in case of cancellation
    recordData.dataSystemUsers = dataUserRowData;
    setEditOpen(false);
    reRender = reRender + 1; //this is to force a re-render/refresh of the data
  };

  const handleDataAccessCancel = (event, reason) => {

    setDataAccessOpen(false);
  };

  const handleDataAccessSave = (event, reason) => {
    if (reason && reason === "backdropClick")
      return;

    debugger;
    // replace the item in recordData.dataSystemUsers array with the updated item
    var index = recordData.dataSystemUsers.findIndex(x => x.id === dataSystemUserId);
    if (index !== -1) { //updating existing record in the array
      // recordData.dataSystemUsers[index] = dataSystemAccessToSave;
      recordData.dataSystemUsers[index].dataSystemId = dataSystemId; //systemAccessForm.getValues("dataSystemId");
      recordData.dataSystemUsers[index].dataUse = systemAccessForm.getValues("dataUse");
      recordData.dataSystemUsers[index].dataRetention = systemAccessForm.getValues("dataRetention");
      recordData.dataSystemUsers[index].selectedDataTypes = dataTypesSelected;
      recordData.dataSystemUsers[index].dataSignOff = systemAccessForm.getValues("dataSignoff");
      recordData.dataSystemUsers[index].accessLevelId = accessLevelId; //systemAccessForm.getValues("accessLevelId");
      recordData.dataSystemUsers[index].accessPurposeSelected = accessPurposeSelected;
      recordData.dataSystemUsers[index].dataUsesSelected = dataUsesSelected;
      recordData.dataSystemUsers[index].dataStorageSelected = dataStorageSelected;
      recordData.dataSystemUsers[index].accessMethodSelected = accessMethodSelected;
      //update dataSystemName based on dataSystemId
      recordData.dataSystemUsers[index].dataSystemName = recordData.dataSystems[recordData.dataSystems.findIndex(x => x.id === dataSystemId)].system;   //find name in dataSystems
    }
    else { //adding new record to the array

      var newRecord = {
        // id: systemAccessForm.getValues("id"),
        id: -1, //add
        dataUserId: getValues("id"),
        dataSystemId: dataSystemId, //systemAccessForm.getValues("dataSystemId"),
        dataSystemName: recordData.dataSystems[recordData.dataSystems.findIndex(x => x.id === dataSystemId)].system,   //find name in dataSystems
        dataUse: systemAccessForm.getValues("dataUse"),
        dataRetention: systemAccessForm.getValues("dataRetention"),
        selectedDataTypes: dataTypesSelected,
        dataSignOff: systemAccessForm.getValues("dataSignoff"),
        accessLevelId: accessLevelId, //systemAccessForm.getValues("accessLevelId"),
        accessPurposeSelected: accessPurposeSelected,
        dataUsesSelected: dataUsesSelected,
        dataStorageSelected: dataStorageSelected,
        accessMethodSelected: accessMethodSelected
      };
      const updatedArray = [...recordData.dataSystemUsers, newRecord];
      recordData.dataSystemUsers = updatedArray;
      debugger;
    }



    //   dataRetention: systemAccessForm.getValues("dataRetention"),
    //   selectedDataTypes: dataTypesSelected,
    //   dataSignOff: systemAccessForm.getValues("dataSignoff"),
    //   accessPurposeSelected: accessPurposeSelected,
    //   dataUsesSelected: dataUsesSelected,
    //   dataStorageSelected: dataStorageSelected,
    //   accessMethodSelected: accessMethodSelected,
    //   accessLevelId: systemAccessForm.getValues("accessLevelId")
    // };

    setDataAccessOpen(false);
  };


  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };

  const handleDeclarationCancel = () => {
    setDeclarationOpen(false);
  };
  const handleDeclaration = () => {
    setDeclarationOpen(false);
    saveDataUser(null, 'SendAll', recordData.accessToken);  //send declaration
  };

  const handleDelete = () => {
    var data = { id: deleteId };
    // data.id = deleteId;

    saveDataUser(data, 'Delete', accessToken);
    reRender = reRender + 1;
    setDeleteOpen(false);
  };

  const handleSystemAccessDelete = () => {

    var dataSystemUser = recordData.dataSystemUsers.find(x => x.dataUserId === dataUserIdForSystemAccessDelete && x.dataSystemId === deleteId);
    if (!dataSystemUser) {
      showError("Could not find the system access record to delete");
      return;
    }
    // if (dataSystemUser.id < 0) { //if the id is less than 0, it means it has not been saved to the database yet, so we can just remove it from the array
    //remove from array in memory
    recordData.dataSystemUsers = recordData.dataSystemUsers.filter(x => x.dataUserId !== dataUserIdForSystemAccessDelete || x.dataSystemId !== deleteId);
    // }
    //refreshData = refreshData + 1;
    setSystemAccessDeleteOpen(false);
  };

  const handleSystemAccessDeleteCancel = () => {
    setSystemAccessDeleteOpen(false);
  };


  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };

  const titleBoxBackgroundColour = '#1976d21a';

  const handleDepartmentChange = (event, cloudProviderOtherValue) => {
    setValue('departmentId', event.target.value, { shouldValidate: true });
  }

  const handleEmploymentTypeChange = (event) => {
    setValue('employmentTypeId', event.target.value, { shouldValidate: true });
    if (event.target.value === -1) {
      setEmploymentTypeOtherShow(true);
    } else {
      setEmploymentTypeOtherShow(false);
    }
  }

  const handleSystemUserChange = (event) => {
    // debugger;
    //systemAccessForm.setValue('dataSystemId', event.target.value, { shouldValidate: true });
    setDataSystemId(event.target.value);
    //setValue('dataSystemUserId', event.target.value, { shouldValidate: true });
  }

  const handleAccessLevelChange = (event) => {
    //TODO:need to figure this out
    //systemAccessForm.setValue('accessLevelId', event.target.value, { shouldValidate: true });
    setAccessLevelId(event.target.value);
    //setValue('accessLevelId', event.target.value, { shouldValidate: true });
    calculateRiskLevel();
  }

  if (loading) {
    return (
      // <div>
      //   Loading...
      // </div>

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  } else if (loading === false && error !== null) {
    return (
      <Stack spacing={2}>
        <Alert severity="error">Error occured loading data users</Alert>
      </Stack>

    )
  }

  return (
    <div>
      <SuccessError
        successMessage={successMessage}
        errorMessage={errorMessage}
        closeError={() => closeError()}
        closeSuccess={() => closeSuccess()}
        successOpen={successOpen}
        errorOpen={errorOpen}
      >
      </SuccessError>
      {(requestCode === null) && (<>

        <Box
          component="span"
          m={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h3" component="h2">
            Data Users
          </Typography>
          <Button variant="outlined" onClick={sendAllDeclarations} sx={{ marginLeft: "auto" }} >Send Yearly Declaration</Button>
          <Button variant="outlined" onClick={addDataUser}>Add Data User</Button>
        </Box>
      </>
      )}
      <div>

        <div style={{ height: '70vh', width: '100%' }}>
          {(requestCode === null) && (<>

            <DataGrid
              //componentsProps={{ toolbar: { csvOptions: { allColumns: true } } }} 
              fullWidth

              components={{
                Toolbar: CustomToolbar,
              }}
              initialState={{
                pagination: {
                  pageSize: 1000,
                },
              }}
              height='100%'
              rows={recordData.dataUsers}
              columns={columns}
              //pageSize={100}
              rowsPerPageOptions={[50, 100]}
            //checkboxSelection
            />
          </>
          )}
        </div>
        <div>

          <Tooltip id='newToolTip' title='Click to copy URL to send to a NEW user to fill out info'>
            <Button onClick={handleClipboardCopy}>Click to copy URL for new User &nbsp;<ContentCopyIcon  ></ContentCopyIcon> <span id='copiedMsg'></span></Button>
          </Tooltip>
        </div>

        <Dialog open={dataAccessOpen} onClose={handleDataAccessCancel} maxWidth="md" fullWidth
          scroll={'paper'}
        >

          <DialogTitle
            sx={{ padding: "3px 39px" }}
          >{editOrAddTitle} Data System Access
            <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
              * = required
            </Typography>

          </DialogTitle>

          <DialogContent>
            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
              onClick={() => setGeneralOpen(!generalOpen)}
            >
              <Grid container sx={{ justifyContent: "space-between" }} >
                <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                  Data System Access
                </Typography>
                <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                  {generalOpen ? <RemoveIcon /> : <AddIcon />}
                </Typography>

              </Grid>
            </Box>


            <Collapse in={generalOpen} width={'100%'}>
              <Box sx={{ border: 1 }} px={2} py={1}>
                <form onSubmit={systemAccessForm.handleSubmit(onSubmitSystemAccess)}>

                  <Fragment>
                    <Grid container spacing={1}>

                      <Grid item xs={12} sm={12}>
                        <TextField
                          // required
                          id="idSystemAccess"
                          name="id"
                          label="ID"
                          fullWidth
                          hidden
                          margin="dense"
                          {...systemAccessForm.register('id')}

                        />

                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl sx={{ m: 0, minWidth: 350, paddingTop: 1 }}>

                          <InputLabel sx={{ paddingTop: 1.5 }}>Data System</InputLabel>
                          <Controller
                            name="dataSystemId"
                            control={systemAccessForm.control}

                            render={({ field: { onChange, value } }) => (
                              <Select id={'dataSystemId'}
                                // value={systemAccessForm.value}
                                value={dataSystemId ? dataSystemId.toString() : ''}
                                {...systemAccessForm.register('dataSystemId')}
                                label="Data System"
                                onChange={e => handleSystemUserChange(e)}
                              >
                                {dataSystems.map((item, index) => <MenuItem key={index} value={item.id}>{item.system}</MenuItem>)}

                              </Select>
                            )} />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.dataSystemId?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <FormControl sx={{ m: 0, minWidth: 350, paddingTop: 1 }}>

                          <InputLabel sx={{ paddingTop: 1.5 }}>Access Level</InputLabel>
                          <Controller
                            name="accessLevelId"
                            control={systemAccessForm.control}

                            render={({ field: { onChange, value } }) => (
                              <Select id='accessLevelId'
                                // value={systemAccessForm.value}
                                value={accessLevelId ? accessLevelId.toString() : ''}
                                // {...systemAccessForm.register('accessLevelId')}
                                label="Access Level"
                                onChange={e => handleAccessLevelChange(e)}
                              >
                                {accessLevels.map((item, index) => <MenuItem key={index} value={item.lookupItemId}>{item.name}</MenuItem>)}

                              </Select>
                            )} />
                        </FormControl>
                        <Typography variant="inherit" color="error.main">
                          {errors.accessLevelId?.message}
                        </Typography>
                      </Grid>

                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips

                          label="Purpose of Access"
                          name="accessPurposeSelected"
                          control={systemAccessForm.control}
                          // backgroundColor="#ecf7eb"
                          value={accessPurposeSelected}
                          infoSelected={accessPurposeSelected}
                          //infoNASelected={accessPurposeNASelected}
                          setinfoSelected={setAccessPurposeSelected}
                          onChange={handleAccessPurposeChange}
                          handleChipDelete={handleChipDeleteForAccessPurposes}
                          errors={errors.accessPurposeSelected}

                          items={accessPurposes}
                        >
                        </MultiSelectWithChips>

                      </Grid>
                      {/* <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "0px" }}>
                        <Tooltip title="Description:
                                        This field describes why the school uses this application and what educational or operational function it supports. Schools should select the primary purpose(s) that most accurately reflect how the tool is used in practice, adding brief clarification only where necessary.
                                        Why it matters:
                                        GDPR requires schools to demonstrate that personal data is collected for clear, specific, and legitimate purposes. Clear purposes support transparency, data minimization, and accountability.">
                          <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                      </Grid> */}

                      {accessPurposeSelected.includes('Other') && (
                        <Grid item xs={6} sm={6}>
                          <TextField
                            //required
                            control={systemAccessForm.control}
                            InputLabelProps={{ shrink: true }}
                            placeholder='Other Purpose of Access'
                            id="otherPurposeOfAccess"
                            name="otherPurposeOfAccess"
                            label="Other Purpose of Access"
                            fullWidth
                            margin="dense"
                            {...systemAccessForm.register('otherPurposeOfAccess')}
                            error={errors.otherPurposeOfAccess ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.otherPurposeOfAccess?.message}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips
                          label="How the data is used"
                          name="dataUsesSelected"
                          control={systemAccessForm.control}
                          value={dataUsesSelected}
                          infoSelected={dataUsesSelected}
                          //infoNASelected={studentInfoNASelected}
                          setinfoSelected={setDataUsesSelected}
                          onChange={handleDataUsesChange}
                          handleChipDelete={handleChipDeleteForDataUses}
                          errors={errors.dataUsesSelected}

                          items={dataUses}
                        >
                        </MultiSelectWithChips>


                        <Typography variant="inherit" color="error.main">
                          {errors.dataUsesSelected?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips
                          label="Data Storage / Retention Handling"
                          name="dataStorageSelected"
                          control={systemAccessForm.control}
                          value={dataStorageSelected}
                          infoSelected={dataStorageSelected}
                          //infoNASelected={studentInfoNASelected}
                          setinfoSelected={setDataStorageSelected}
                          onChange={handleDataStorageChange}
                          handleChipDelete={handleChipDeleteForDataStorage}
                          errors={errors.dataStorageSelected}

                          items={dataStorageItems}
                        >
                        </MultiSelectWithChips>


                        <Typography variant="inherit" color="error.main">
                          {errors.dataStorage?.message}
                        </Typography>
                      </Grid>
                      {dataStorageSelected.includes('Other') && (
                        <Grid item xs={6} sm={6}>
                          <TextField
                            //required
                            control={systemAccessForm.control}
                            InputLabelProps={{ shrink: true }}
                            placeholder='Other Retention Description'
                            id="otherDataStorage"
                            name="otherDataStorage"
                            label="Other Retention Description"
                            fullWidth
                            margin="dense"
                            {...systemAccessForm.register('otherDataStorage')}
                            error={errors.otherDataStorage ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.otherDataStorage?.message}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={5} sm={5}>
                        <MultiSelectWithChips
                          label="Device / Access Method"
                          name="accessMethodSelected"
                          control={systemAccessForm.control}
                          value={accessMethodSelected}
                          infoSelected={accessMethodSelected}
                          //infoNASelected={studentInfoNASelected}
                          setinfoSelected={setAccessMethodSelected}
                          onChange={handleAccessMethodChange}
                          handleChipDelete={handleChipDeleteForAccessMethods}
                          errors={errors.accessMethodSelected}

                          items={accessMethodItems}
                        >
                        </MultiSelectWithChips>


                        <Typography variant="inherit" color="error.main">
                          {errors.accessMethodSelected?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          disabled={true}
                          //required
                          control={systemAccessForm.control}
                          InputLabelProps={{ shrink: true }}
                          placeholder='Completion Date'
                          id="completionDate"
                          name="completionDate"
                          label="Completion Date"
                          fullWidth
                          margin="dense"
                          {...systemAccessForm.register('completionDate')}
                          error={errors.completionDate ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.completionDate?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} style={{ paddingLeft: 10, paddingTop: 10 }}   >
                        <Typography>Risk Level</Typography>
                      </Grid>
                      <Grid item xs={10} sm={10} md={10} style={{ paddingLeft: 10, paddingTop: 10 }} >

                        {/* <FormControl> */}
                        {/* <FormLabel id="demo-radio-buttons-group-label">Subcontractors required to protect data</FormLabel> */}
                        <RadioGroup
                          row
                          aria-labelledby="demo-radio-buttons-group-label"

                          name="radio-buttons-group"

                        >
                          <ToggleButtonGroup value={riskLevelButton} exclusive onChange={handleRiskLevelChange}>
                            {/* {riskLevel <= 4 && ( */}
                            <ToggleButton value={0} selectedColor="grey" onMouseEnter={() => handleRiskText('None: This is data that is not disclosed to the public. It carries no risk if openly revealed to the public.')} >

                              <span>Minimal</span>

                            </ToggleButton>
                            {/* )} */}

                            {/* {riskLevel > 4 && riskLevel <= 9 && ( */}
                            <ToggleButton value={1} selectedColor="lightgreen" onMouseEnter={() => handleRiskText('Low: This data is known to most or all employees. If this data is revealed, it may have low or no impact on the institution')}>

                              <span> Medium </span>

                            </ToggleButton>
                            {/* )} */}
                            {/* {riskLevel > 9 && riskLevel <= 16 && ( */}

                            <ToggleButton value={2} selectedColor="Orange" onMouseEnter={() => handleRiskText('Medium: This information is created for the internal use of the institution, and it’s not meant to be revealed. If revealed, it may have a moderate impact on the institution.')}>

                              <span> High </span>

                            </ToggleButton>
                            {/* )} */}
                            {/* {riskLevel > 16 && ( */}

                            <ToggleButton value={3} selectedColor="Red" onMouseEnter={() => handleRiskText('High: This is the most confidential data and revealing it can lead to huge financial or reputational losses to the institution.')}>

                              <span> Very High (Special Category Data)</span>

                            </ToggleButton>
                            {/* )} */}
                          </ToggleButtonGroup>

                        </RadioGroup>
                        {/* </FormControl> */}
                        {/* <Typography variant="inherit" color="error.main">
                        {errors.commonSense?.message}
                      </Typography> */}

                      </Grid>

                      {/* <Grid item xs={5} sm={5}>
                      <MultiSelectWithChips
                        label="Data Types"
                        name="dataTypesSelected"
                        control={controlSystemAccess}
                        value={dataTypesSelected}
                        infoSelected={dataTypesSelected}
                        //infoNASelected={studentInfoNASelected}
                        setinfoSelected={setDataTypesSelected}
                        onChange={handleDataTypesChange}
                        handleChipDelete={handleChipDeleteForDataTypes}
                        errors={errors.dataTypes}

                        items={dataTypesItems}
                      >
                      </MultiSelectWithChips>


                      <Typography variant="inherit" color="error.main">
                        {errors.departmentsSelected?.message}
                      </Typography>
                    </Grid> */}

                      {/* <Grid item xs={12} sm={12}>
                      <TextField
                        //required
                        control={control}
                        InputLabelProps={{ shrink: true }}
                        placeholder='Describe how long this data is kept active.'
                        id="dataRetention"
                        name="dataRetention"
                        label="Data Retention"
                        fullWidth
                        margin="dense"
                        {...register('dataRetention')}
                        error={errorsSystemAccess.dataRetention ? true : false}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.dataRetention?.message}
                      </Typography>
                    </Grid> */}
                      {/* <Grid item xs={6} sm={6} md={6}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox checked={dataSignoff} onChange={handleDataSignoffChange} />} label="Data Sign-off" />

                      </FormGroup>
                      <Typography variant="inherit" color="error.main">
                        {errors.dataSignOff?.message}
                      </Typography>
                    </Grid> */}



                    </Grid>
                  </Fragment>
                  <DialogActions>
                    {/* <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={runValidations}>Validate</Button> */}
                    {/* <Button color="primary" type="submit" onClick={systemAccessForm.handleSubmit(onSubmitSystemAccess)}>Savex</Button> */}
                    <Button color="primary" type="submit" onClick={handleDataAccessSave}>Save</Button>

                    <Button onClick={handleDataAccessCancel}>Cancel</Button>

                  </DialogActions>
                </form>
              </Box>
            </Collapse>
          </DialogContent>



        </Dialog>

        <Dialog open={editOpen} onClose={handleCancel} maxWidth="md" fullWidth
          scroll={'paper'}
        >

          <DialogTitle
            sx={{ padding: "3px 39px" }}
          >{editOrAddTitle} Data User
            <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
              * = required
            </Typography>

          </DialogTitle>

          <DialogContent>
            <SuccessError

              errorMessage={errorMessage}
              closeError={() => closeError()}
              closeSuccess={() => closeSuccess()}

              errorOpen={errorDialogOpen}
            >
            </SuccessError>
            <Fragment>
              <Paper variant="outlined" >
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setGeneralOpen(!generalOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }} >
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data User
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {generalOpen ? <RemoveIcon /> : <AddIcon />}
                    </Typography>

                  </Grid>
                </Box>


                <Collapse in={generalOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={1}>

                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          id="id"
                          name="id"
                          label="ID"
                          fullWidth
                          hidden
                          margin="dense"
                          {...register('id')}

                        />

                      </Grid>
                      <Grid item xs={3} sm={3}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="First Name"
                          id="firstName"
                          name="firstName"
                          label="First Name"
                          fullWidth
                          margin="dense"
                          {...register('firstName')}
                          error={errors.firstName ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.firstName?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} sm={3}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="Last Name"
                          id="lastName"
                          name="lastName"
                          label="Last Name"
                          fullWidth
                          margin="dense"
                          {...register('lastName')}
                          error={errors.lastName ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.lastName?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="Email"
                          id="email"
                          name="email"
                          label="Email"
                          fullWidth
                          margin="dense"
                          {...register('email')}
                          error={errors.email ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.email?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4}>
                        <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                          <InputLabel sx={{ paddingTop: 1.5 }}>Department</InputLabel>
                          <Controller
                            name="departmentId"
                            control={control}

                            render={({ field: { onChange, value } }) => (
                              <Select id='departmentId'
                                value={value}
                                label="Department"
                                onChange={e => handleDepartmentChange(e)}
                              >
                                {departments.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                              </Select>
                            )} />
                        </FormControl>
                        {/* <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={runValidations}>Validate</Button> */}
                        <Typography variant="inherit" color="error.main">
                          {errors.cloudProviderId?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4}>
                        <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                          <InputLabel sx={{ paddingTop: 1.5 }}>Employment Type</InputLabel>
                          <Controller
                            name="employmentTypeId"
                            control={control}

                            render={({ field: { onChange, value } }) => (
                              <Select id='employmentTypeId'
                                value={value}
                                label="Employment Type"
                                onChange={e => handleEmploymentTypeChange(e)}
                              >
                                {employmentTypes.map((mode, index) => <MenuItem key={index} value={mode.employmentTypeId}>{mode.name}</MenuItem>)}

                              </Select>
                            )} />
                        </FormControl>
                        {/* <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={runValidations}>Validate</Button> */}
                        <Typography variant="inherit" color="error.main">
                          {errors.employmentTypeId?.message}
                        </Typography>
                      </Grid>
                      {employmentTypeOtherShow && (
                        <Fragment>
                          <Grid item xs={4} sm={4} md={4}>
                            <formControl >
                              <TextField sx={{ paddingTop: 1 }}
                                label="Please specify other employment type"
                                {...register("employmentTypeOther")}
                                error={!!errors.employmentTypeOther}
                                helperText={errors.employmentTypeOther?.message}
                              />
                            </formControl>
                          </Grid>
                          <Typography variant="inherit" color="error.main">
                            {errors.employmentTypeOther?.message}
                          </Typography>
                        </Fragment>
                      )}
                      {(requestCode !== null) && (<> <Grid item xs={12} sm={12}>
                        <FormGroup>
                          <FormControlLabel control={<Checkbox checked={dataSignoff} onChange={handleDataSignOffChange} />} label="By checking this box you agree to follow all of the policies and procedures at the school in relation to data privacy, including but not limited to, ensure that no private school data is downloaded onto personal devices, and that you will only access the data required to perform your duties in your role at the school." />

                        </FormGroup>
                        <Typography variant="inherit" color="error.main">
                          {errors.dataUse?.message}
                        </Typography>
                      </Grid>


                      </>)}



                    </Grid>
                  </Box>
                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setDataAccessOpen(!dataAccessOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }} >
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data User System Access
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {systemAccessOpen ? <RemoveIcon /> : <AddIcon />}
                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={systemAccessOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={1}>
                      <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={addSystemAccess}>Add System Access</Button>
                      <Grid item xs={12} sm={12} height={500}>
                        <DataGrid
                          filterModel={{
                            items: filt
                          }}
                          fullWidth


                          initialState={{
                            pagination: {
                              pageSize: 1000,
                            },
                          }}
                          height='100%'
                          rows={recordData.dataSystemUsers}
                          columns={columnsUserAccess}
                          //pageSize={100}
                          rowsPerPageOptions={[50, 100]}
                        //checkboxSelection
                        />

                      </Grid>
                    </Grid>
                  </Box>
                </Collapse>
              </Paper>
            </Fragment>
          </DialogContent>

          <DialogActions>
            {(requestCode === null) && (<>
              <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </>)}
            {(requestCode !== null) && (<>
              <Button color="primary" variant="outlined" onClick={handleSubmit(onSubmitComplete)}>Save and Complete</Button>
              {/* <Button color="primary" variant="outlined" onClick={handleSubmit(onSubmitInProgress)}>Save and Finish Later</Button> */}
              <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
            </>)}
          </DialogActions>


        </Dialog>

        <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Data User</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete <strong>{deleteName} ?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Delete</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={systemAccessDeleteOpen} onClose={handleSystemAccessDeleteCancel}>
          <DialogTitle>Delete System Access</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete <strong>{deleteName} ?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleSystemAccessDelete}>Delete</Button>
            <Button onClick={handleSystemAccessDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={declarationOpen} onClose={handleDeclarationCancel}>
          <DialogTitle>Send Declarations</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to send declaration emails?  This will send to all users on this list and reset the completion status until the user completes the form.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDeclaration}>Send Declarations</Button>
            <Button onClick={handleDeclarationCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </div>

    </div>


  );

}
